import { animate, style, transition, trigger } from '@angular/animations';

export const FADE_IN_OUT_ANIMATION = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate('250ms', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('250ms', style({ opacity: 0 }))])
]);

export const SLIDE_UP_DOWN_ANIMATION = trigger('slideUpDown', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(20px)' }),
    animate('250ms', style({ opacity: 1, transform: 'translateY(0)' }))
  ]),
  transition(':leave', [style({ opacity: 1 }), animate('250ms', style({ opacity: 0, transform: 'translateY(20px)' }))])
]);

export const SLIDE_LEFT_RIGHT_ANIMATION = trigger('slideLeftRight', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateX(-25%)' }),
    animate('250ms', style({ opacity: 1, transform: 'translateX(0)' }))
  ]),
  transition(':leave', [style({ opacity: 1 }), animate('250ms', style({ opacity: 0, transform: 'translateX(25%)' }))])
]);

export const SLIDE_LEFT_ANIMATION = trigger('slideLeft', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateX(-75%)' }),
    animate('350ms cubic-bezier(.54,.76,.51,1.03)', style({ opacity: 1, transform: 'translateX(0)' }))
  ]),
  transition(':leave', [
    style({ opacity: 1 }),
    animate('350ms cubic-bezier(.54,.76,.51,1.03)', style({ opacity: 0, transform: 'translateX(-75%)' }))
  ])
]);
